module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.viewType == 'list') ? _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "col-sm-1 col-md-1 col-lg-1",
    staticStyle: {
      "margin-top": "10px",
      "text-align": "left"
    },
    attrs: {
      "for": "recordPerPage"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-md-2 col-lg-1",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('select', {
    ref: "recordPerPage",
    staticClass: "form-control",
    on: {
      "change": _vm.changePageSize
    }
  }, [(_vm.inquiryParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.inquiry
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listData), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "width": "45px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "85px",
        "text-align": "right"
      }
    }, [_c('a', {
      ref: "displayRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplay(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "editRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEdit(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "deleteRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDelete(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n                  Page\n              ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryParam.CurrentPageNumber),
      expression: "inquiryParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "type": "text",
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.totalPages) + "                \n              ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPages)
      }
    }
  })])])])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewType == 'form') ? _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Membership Type Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "45px",
      "text-align": "center"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Name")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb7ef074"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Religion.vue
// module id = 817
// module chunks = 1